module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docer-aside"
  }, [_c('div', {
    staticClass: "aside-header",
    attrs: {
      "id": "aside_header"
    }
  }, [_c('a', {
    staticClass: "icon-menu",
    attrs: {
      "href": "javascript:void(0);",
      "id": "btn_menu"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuVisible),
      expression: "menuVisible"
    }],
    staticClass: "menu-wrapper",
    attrs: {
      "id": "menu_wrapper"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);",
      "ga": "/userframe/usercenter;click"
    },
    on: {
      "click": function($event) {
        return _vm.qingOpenUrl('https://account.wps.com/usercenter/?from=mywps')
      }
    }
  }, [_vm._v("User Center\n            ")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    attrs: {
      "href": "javascript:void(0);",
      "ga": "/userframe/signout;click"
    },
    on: {
      "click": function($event) {
        return _vm.userLogout()
      }
    }
  }, [_vm._v("Sign Out\n            ")])])]), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "user-wrapper tac clearfix"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discount.shouldShow && _vm.userInfo.vip_level != 210),
      expression: "discount.shouldShow && userInfo.vip_level != 210"
    }],
    staticClass: "discount-flag",
    attrs: {
      "src": require("../../assets/images/discount_flag_v2.png")
    },
    on: {
      "click": function($event) {
        return _vm.goDiscount()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": _vm.userInfo.avatar
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-nickname"
  }, [_vm._v(_vm._s(_vm.userInfo.nickname || 'unknown'))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userInfo.vip_level != 210),
      expression: "userInfo.vip_level != 210"
    }],
    staticClass: "user-subscribe",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.goPremium
    }
  }, [_vm._v("Go Premium\n        ")])]) : (!_vm.isLogin) ? _c('div', {
    staticClass: "user-wrapper tac"
  }, [_c('i', {
    staticClass: "icon-login",
    attrs: {
      "ga": "/userframe/avatar;click"
    },
    on: {
      "click": function($event) {
        return _vm.userLogin()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-msg"
  }, [_vm._v(_vm._s(_vm.discount.shouldShow ? '' : '1G free cloud storage for WPS user'))]), _vm._v(" "), _c('button', {
    staticClass: "btn-login",
    attrs: {
      "ga": "/userframe/getit;click"
    },
    on: {
      "click": function($event) {
        return _vm.userLogin()
      }
    }
  }, [_vm._v(_vm._s(_vm.discount.shouldShow ? 'Sign in for Discount' : 'Get It') + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'dividing-line login-divide' : 'dividing-line logout-divide'
  }), _vm._v(" "), _c('div', {
    staticClass: "file-tips clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("Recent files")]), _vm._v(" "), _c('i', {
    staticClass: "icon-refresh",
    attrs: {
      "id": "icon_refresh"
    },
    on: {
      "click": function($event) {
        return _vm.getRectFiles()
      }
    }
  })]), _vm._v(" "), (_vm.isLogin) ? _c('span', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "dib",
    attrs: {
      "title": "Documents that opened with WPS Office are automatically uploaded to WPS Cloud -> My Cloud -> Auto uploaded."
    }
  }, [_vm._v("Auto upload")]), _vm._v(" "), _c('i', {
    class: _vm.roamingMode === 'auto' ? 'icon-switch-active' : 'icon-switch',
    attrs: {
      "ga": '/userframe/fileroamingservice;' + _vm.roamingMode === 'auto' ? 'open' : 'close'
    },
    on: {
      "click": function($event) {
        return _vm.setRoamingMode(_vm.roamingMode)
      }
    }
  })]) : (!_vm.isLogin) ? _c('span', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "dib"
  }, [_c('a', {
    staticClass: "a-tdu",
    attrs: {
      "href": "javascript:void(0);",
      "ga": "/userframe/signin;click"
    },
    on: {
      "click": function($event) {
        return _vm.userLogin()
      }
    }
  }, [_vm._v("Sign in\n                ")])]), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("to get Cloud documents")])]) : _vm._e()]), _vm._v(" "), (_vm.fileLists.length > 0) ? _c('ul', {
    staticClass: "file-list",
    style: ({
      height: _vm.setListHeight(_vm.userInfo.userid ? 280 : 350),
      minHeight: '50px'
    })
  }, _vm._l((_vm.fileLists), function(file, index) {
    return _c('li', [_c('a', {
      class: file.isExist ? 'ellipsis' : 'file-not-exist ellipsis',
      attrs: {
        "href": "javascript:void(0);",
        "title": file.isExist ? file.fileName : 'Invalid record. This file may be renamed, deleted or moved'
      },
      on: {
        "click": function($event) {
          return _vm.openFile(file)
        }
      }
    }, [(file.isCloudFile) ? _c('i', {
      staticClass: "icon-file-cloud"
    }) : (!file.isCloudFile) ? _c('i', {
      staticClass: "icon-file"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "dib"
    }, [_vm._v(_vm._s(file.fileName.substr(0, 30)))]), _vm._v(" "), _c('span', {
      class: file.isExist ? 'file-handle' : 'file-handle file-handle-unexist'
    }, [_c('i', {
      staticClass: "rm-rect",
      attrs: {
        "title": "Clear Record from List"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeRectFile(file)
        }
      }
    }), _vm._v(" "), (file.isExist) ? _c('span', [(file.isFixed) ? _c('i', {
      staticClass: "rm-rect-fix",
      attrs: {
        "title": "Unfixed from List"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeRectFixedFile(file)
        }
      }
    }) : _c('i', {
      staticClass: "add-fix",
      attrs: {
        "title": "Fixed to List"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addRectFixedFile(file)
        }
      }
    })]) : _vm._e()])])])
  }), 0) : (_vm.fileLists.length === 0) ? _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "icon-file-empty"
  }), _vm._v(" "), _c('p', {
    staticClass: "fs14"
  }, [_vm._v("There is no recent file!")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-more-file",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openFileDialog()
      }
    }
  }, [_c('i', {
    staticClass: "icon-more-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "dib text-more-file"
  }, [_vm._v("Get more files")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-606bb5b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/v2/main/UserFrame.vue
// module id = 102
// module chunks = 1